<template>
  <ul :style="progressVars">
    <li
      v-for="(product, index) in products"
      :class="{ selected: index <= currentProductIndex }"
      :key="product.type"
    >
      <img :src="product.icon" :alt="product.label" />
    </li>
  </ul>
</template>

<script>
export default {
  name: "PackageProgress",
  computed: {
    products() {
      return this.$store.state.products;
    },
    progressVars() {
      return {
        "--max-width": "500px",
        "--item-size": "50px",
        "--product-count": this.$store.state.products.length,
      };
    },
  },
  props: {
    currentProductIndex: Number,
  },
};
</script>

<style lang="scss" scoped>
ul {
  position: relative;
  z-index: 0;
  display: flex;
  justify-content: space-between;
  max-width: var(--max-width);
  list-style-type: none;
  padding: 0;
  margin: $spacing-medium auto (-$spacing-medium);

  @include media("<medium") {
    --separator-width: calc(
      (
          100vw - (#{$spacing-medium} * 2) -
            (var(--item-size) * var(--product-count))
        ) / (var(--product-count) - 1)
    );
  }

  --separator-width: calc(
    (var(--max-width) - (var(--item-size) * var(--product-count))) /
      (var(--product-count) - 1)
  );

  li {
    width: var(--item-size);
    height: var(--item-size);

    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    font-size: 1.2rem;
    padding: 5px;
    border-radius: 50%;
    background: $grey-mid;

    img {
      height: 25px;
    }

    &.selected {
      background: $brand-gradient;

      img {
        filter: brightness(0) invert(1);
      }
    }

    &:before {
      content: "";
      position: absolute;

      top: 23px;
      left: calc(var(--separator-width) * -1);
      width: var(--separator-width);
      height: 4px;

      background: $grey-mid;
    }

    &:first-child:before {
      display: none;
    }

    &.selected:before {
      background: $brand-gradient-reverse;
    }
  }
}
</style>
